<template>
  <div class="item">
    <div class="top">
      <div>订单编号 {{ orderId }}</div>
      <div>{{ convertTime(createTime) }}</div>
    </div>
    <router-link :to="getRouteUrl" class="buttom">
      <div>{{ goodsName }}</div>
      <div>{{ productTypeName }}</div>
      <div>{{ periodDescription }}</div>
      <div>{{ amount }}</div>
      <div>{{ getOrderStatusDescription(orderStatus) }}</div>
      <div>
        <template v-if="orderStatus == 1">
          <a class="abtn" @click="pay">支付</a>
          <div class="paytime-left">剩{{ paytimeLeft }}自动关闭</div>
        </template>
      </div>
    </router-link>
  </div>
</template>

<script>
import dayjs from 'dayjs'
export default {
  name: 'OrderListItem',
  props: {
    orderId: {
      type: String
    },
    productId: {
      type: Number
    },
    createTime: {
      type: Number
    },
    expireTime: {
      type: Number
    },
    goodsName: {
      type: String
    },
    productTypeName: {
      type: String
    },
    periodDescription: {
      type: String
    },
    amount: {
      type: Number
    },
    orderStatus: {
      type: Number
    },
    targetId: { type: Number },
    productType: { type: Number }
  },
  data() {
    return {
      orderStatusList: [
        { description: '待支付', val: 1 },
        { description: '支付失败', val: 2 },
        { description: '已完成', val: 3 },
        { description: '已关闭', val: 4 },
        { description: '换货中', val: 5 },
        { description: '退款中', val: 6 },
        { description: '延期中', val: 7 },
        { description: '已退款', val: 8 },
        { description: '已换货', val: 9 },
        { description: '已延期', val: 10 },
        { description: '处理中', val: 11 }
      ],
      paytimeLeft: 0,
      timeId: 0
    }
  },
  computed: {
    getRouteUrl() {
      if (this.targetId > 0 && this.productType > 0) {
        switch (this.productType) {
          case 1:
            return `/jinNang/${this.targetId}`
          case 2:
            return `/course/${this.targetId}`
          case 3:
            return `/author/${this.targetId}`
          default:
            return ''
        }
      }
      return ''
    }
  },
  methods: {
    convertTime(time) {
      return dayjs(time).format('YYYY-MM-DD HH:mm')
    },
    getOrderStatusDescription(val) {
      const status = this.orderStatusList.find(x => x.val === val)
      if (status) {
        return status.description
      }
      return ''
    },
    pay() {
      this.$store.dispatch('cashierDesk/openGoodsAction', {
        setId: this.productId,
        orderId: this.orderId
      })
    },
    getExpireTimeLeft() {
      if (this.orderStatus !== 1) {
        return 0
      }
      const timespan = this.expireTime - dayjs().valueOf()
      if (timespan <= 0) {
        this.paytimeLeft = '00:00'
        clearInterval(this.timeId)
        return
      }
      this.paytimeLeft = dayjs(timespan).format('mm:ss')
    }
  },
  created() {
    if (this.orderStatus === 1) {
      this.getExpireTimeLeft()
      this.timeId = setInterval(this.getExpireTimeLeft, 1000)
    }
  },
  beforeDestroy() {
    clearInterval(this.timeId)
  }
}
</script>

<style lang="scss" scoped>
.item {
  height: 132px;
  background-color: #ffffff;
  border: solid 1px #ebebeb;
  display: flex;
  flex-direction: column;
  margin: 20px 30px 0;
}
.top {
  width: 766px;
  height: 39px;
  background-color: #fafafa;
  border-bottom: 1px solid #ebebeb;
  display: flex;
}
.buttom {
  height: 90px;
  display: flex;
  font-size: 14px;
  color: #262626;
  text-decoration: none;
  > div {
    width: 118px;
    padding: 0 10px;
    display: inline-block;
    margin: auto;
    text-align: center;
    &:nth-child(2),
    &:nth-child(3),
    &:nth-child(4) {
      width: 98px;
    }
  }
}
.top > div {
  font-size: 14px;
  color: #858585;
  display: inline-block;
  margin-left: 30px;
  height: 39px;
  line-height: 39px;
}
.buttom > div {
  font-size: 14px;
  color: #262626;
  width: 138px;
  display: inline-block;
  margin: auto;
}
.buttom > div:first-child {
  margin-left: 30px;
}
a.abtn {
  display: block;
  width: 56px;
  height: 26px;
  line-height: 26px;
  background-color: #ffffff;
  border-radius: 13px;
  border: solid 1px #e64c2e;
  text-decoration: none;
  text-align: center;
  font-size: 14px;
  color: #e64c2e;
  margin: 0 auto;
  cursor: pointer;
}
a.abtn:hover,
a.abtn:active {
  opacity: 0.8;
}
.paytime-left {
  width: 115px;
  height: 12px;
  font-family: MicrosoftYaHei;
  font-size: 12px;
  line-height: 12px;
  letter-spacing: 1px;
  color: #e64c2e;
  margin-top: 14px;
}
</style>
